<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <span class="mr-2 text-h6">
          {{ $t('header') }}
        </span>
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.skipTop"
          :label="$t('skipTop')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.skipBottom"
          :label="$t('skipBottom')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.skipBottomExpanded"
          :label="$t('skipBottomExpanded')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.readUntil"
          :label="$t('readUntil')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.ticketNumberLine"
          :label="$t('ticketNumberLine')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.ticketNumberStart"
          :label="$t('ticketNumberStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.ticketNumberLength"
          :label="$t('ticketNumberLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.settingLine"
          :label="$t('settingLine')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.settingStart"
          :label="$t('settingStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.settingLength"
          :label="$t('settingLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.tractLine"
          :label="$t('tractLine')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.tractStart"
          :label="$t('tractStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.tractLength"
          :label="$t('tractLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.destinationLine"
          :label="$t('destinationLine')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.destinationStart"
          :label="$t('destinationStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.destinationLength"
          :label="$t('destinationLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.contractAccountLine"
          :label="$t('contractAccountLine')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.contractAccountStart"
          :label="$t('contractAccountStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.contractAccountLength"
          :label="$t('contractAccountLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.productLine"
          :label="$t('productLine')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.productStart"
          :label="$t('productStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.productLength"
          :label="$t('productLengthSSP')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.weighedOutAtLine"
          :label="$t('weighedOutAtLine')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.weighedOutAtStart"
          :label="$t('weighedOutAtStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.weighedOutAtLength"
          :label="$t('weighedOutAtLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.inWeightLine"
          :label="$t('inWeightLine')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.inWeightStart"
          :label="$t('inWeightStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.inWeightLength"
          :label="$t('inWeightLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.outWeightLine"
          :label="$t('outWeightLine')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.outWeightStart"
          :label="$t('outWeightStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.outWeightLength"
          :label="$t('outWeightLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.netWeightLine"
          :label="$t('netWeightLine')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.netWeightStart"
          :label="$t('netWeightStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.netWeightLength"
          :label="$t('netWeightLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.trailerIdentifierLine"
          :label="$t('trailerIdentifierLine')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.trailerIdentifierStart"
          :label="$t('trailerIdentifierStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.trailerIdentifierLength"
          :label="$t('trailerIdentifierLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" class="mt-4">
        <span class="mr-2 text-h6">
          {{ $t('log') }}
        </span>
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.speciesStart"
          :label="$t('speciesStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.speciesLength"
          :label="$t('speciesLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.gradeStart"
          :label="$t('gradeStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.gradeLength"
          :label="$t('gradeLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.endUseSortStart"
          :label="$t('endUseSortStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.endUseSortLength"
          :label="$t('endUseSortLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.buttLogStart"
          :label="$t('buttLogStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.buttLogLength"
          :label="$t('buttLogLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12">
        <span class="subtitle-1"> {{ $t('segmentOne') }} </span>
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentOneGradeStart"
          :label="$t('segmentOneGradeStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentOneGradeLength"
          :label="$t('segmentOneGradeLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentOneEndUseSortStart"
          :label="$t('segmentOneEndUseSortStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentOneEndUseSortLength"
          :label="$t('segmentOneEndUseSortLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentOneLengthStart"
          :label="$t('segmentOneLengthStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentOneLengthLength"
          :label="$t('segmentOneLengthLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentOneDiameterStart"
          :label="$t('segmentOneDiameterStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentOneDiameterLength"
          :label="$t('segmentOneDiameterLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentOneGrossVolumeStart"
          :label="$t('segmentOneGrossVolumeStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentOneGrossVolumeLength"
          :label="$t('segmentOneGrossVolumeLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentOneNetVolumeStart"
          :label="$t('segmentOneNetVolumeStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentOneNetVolumeLength"
          :label="$t('segmentOneNetVolumeLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentOneDefectVolumeStart"
          :label="$t('segmentOneDefectVolumeStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentOneDefectVolumeLength"
          :label="$t('segmentOneDefectVolumeLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12">
        <span class="subtitle-1"> {{ $t('segmentTwo') }} </span>
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentTwoGradeStart"
          :label="$t('segmentTwoGradeStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentTwoGradeLength"
          :label="$t('segmentTwoGradeLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentTwoEndUseSortStart"
          :label="$t('segmentTwoEndUseSortStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentTwoEndUseSortLength"
          :label="$t('segmentTwoEndUseSortLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentTwoLengthStart"
          :label="$t('segmentTwoLengthStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentTwoLengthLength"
          :label="$t('segmentTwoLengthLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentTwoDiameterStart"
          :label="$t('segmentTwoDiameterStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentTwoDiameterLength"
          :label="$t('segmentTwoDiameterLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentTwoGrossVolumeStart"
          :label="$t('segmentTwoGrossVolumeStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentTwoGrossVolumeLength"
          :label="$t('segmentTwoGrossVolumeLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentTwoNetVolumeStart"
          :label="$t('segmentTwoNetVolumeStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentTwoNetVolumeLength"
          :label="$t('segmentTwoNetVolumeLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentTwoDefectVolumeStart"
          :label="$t('segmentTwoDefectVolumeStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentTwoDefectVolumeLength"
          :label="$t('segmentTwoDefectVolumeLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12">
        <span class="subtitle-1"> {{ $t('segmentThree') }} </span>
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentThreeLengthStart"
          :label="$t('segmentThreeLengthStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentThreeLengthLength"
          :label="$t('segmentThreeLengthLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentThreeDiameterStart"
          :label="$t('segmentThreeDiameterStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentThreeDiameterLength"
          :label="$t('segmentThreeDiameterLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentThreeGrossVolumeStart"
          :label="$t('segmentThreeGrossVolumeStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentThreeGrossVolumeLength"
          :label="$t('segmentThreeGrossVolumeLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentThreeNetVolumeStart"
          :label="$t('segmentThreeNetVolumeStart')"
          outlined
          readonly
          color="black"
        />
      </v-col>
      <v-col cols="12" md="6" lg="2">
        <v-text-field
          v-model="propProfile.segmentThreeNetVolumeLength"
          :label="$t('segmentThreeNetVolumeLength')"
          outlined
          readonly
          color="black"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'ScaleSheetImportFixedLengthProfileDetail',

  props: {
    propProfile: {
      type: Object,
      required: true
    }
  }
}
</script>
